<script setup lang="ts">
import RelationView from '@desktop/views/Relation/components/RelationView/RelationView.vue'
import { useOnIncidentChangeTeamPossession } from '@desktop/views/Relation/Sports/init'
import { initSportConfiguration } from '@desktop/views/Relation/Sports/provide-inject'

import SoccerRelation from './components/RelationView/SoccerRelation.vue'
import SoccerStatistics from './components/RelationView/SoccerStatistics.vue'
import {
  addIncidentConfig,
  attributesToResetParticipants,
  betIncidents,
  customIncidentNames,
  eventInfoControls,
  eventRelatedStatusConfig,
  eventStatuses,
  eventStatusIncidentsOnFieldConfig,
  extraTimeDetailId,
  getEventClockSeconds,
  getEventClockTime,
  getEventStatusPeriodLengthMinutes,
  handyBarInfoAlwaysVisibleIncidents,
  historyFiltersConfig,
  historyIncidentsConfig,
  importantStatsId,
  incidentIdsGroup,
  incidentsQueuePayloadConfig,
  incidentsRequireConfirmation,
  incidentsRequirePointingPositionConfig,
  incidentsResultConfig,
  incidentsTeamPossessionConfig,
  isValidEventClockTime,
  lineupConfig,
  manualAddIncidentConfig,
  pitchBlockedEventStatus,
  pitchIncidentsConfig,
  pitchOverlaySupportedStatuses,
  pitchPenaltyOverlayConfig,
  playersConfig,
  pocketIncidentsConfig,
  queueIncidentErrorConfig,
  sameTimeIncidentsConfig,
} from './configuration'
import { vipIncidentsConfig } from './configuration/vipIncidentsConfig'

initSportConfiguration({
  addIncidentConfig,
  attributesToResetParticipants,
  betIncidents,
  hasChangeSides: true,
  clock: {
    getEventClockSeconds,
    getEventClockTime,
    getEventStatusPeriodLengthMinutes,
    isValidEventClockTime,
    minutesMaxDigits: 3,
    extraTimeDetailId,
  },
  customIncidentNames,
  defaultSkinPatternId: 1,
  eventInfoControls,
  eventRelatedStatusConfig,
  eventStatuses,
  handyBarInfoAlwaysVisibleIncidents,
  historyFiltersConfig,
  historyIncidentsConfig,
  importantStatsId,
  incidentIdsGroup,
  incidentsQueuePayloadConfig,
  incidentsRequireConfirmation,
  incidentsResultConfig,
  incidentsTeamPossessionConfig,
  lineupConfig,
  manualAddIncidentConfig,
  pitch: {
    eventStatusIncidentsOnFieldConfig,
    incidentsRequirePointingPositionConfig,
    pitchBlockedEventStatus,
    pitchIncidentsConfig,
    pitchOverlaySupportedStatuses,
    pitchPenaltyOverlayConfig,
  },
  playersConfig,
  pocketIncidentsConfig,
  sameTimeIncidentsConfig,
  queueIncidentErrorConfig,
  verifyResultSummaryConfig: {
    isDrawPossible: true,
    showParticipantStats: true,
  },
  vipIncidentsConfig,
})

useOnIncidentChangeTeamPossession(
  incidentsTeamPossessionConfig.changePossessionIncidents,
)
</script>

<template>
  <RelationView
    :relation="SoccerRelation"
    :statistics="SoccerStatistics"
  />
</template>
